import React from 'react';
import { Tooltip } from 'antd';

export const renderPhdAbbreviatedValue = (value, fullValue) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  if (!fullValue || fullValue === value) {
    return value;
  }

  return (
    <Tooltip title={fullValue}>
      <span>{value}</span>
    </Tooltip>
  );
};
